import { keyframes } from "styled-components";


export const EntranceAnimation = keyframes`
    from {
        transform: scale(0.7);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
`

export const FadeAnimation = keyframes`
    from {
        opacity: 0;
    } 
    to {
        opacity: 1;
    }
`

export const ConfirmationPopupAnimation = keyframes`
    from { 
        transform: scale(0.85); 
    }
    to { 
        transform: scale(1); 
    }
`
